module.exports = __webpack_public_path__ + "img/flutter.eda67f52.svg";